import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'
import { buildSelectionSwitchBlock } from './demoSelectionSwitch.js'
import {
  DESIGN_DNA_SHOWCASE_COMPLETE_CALLOUT,
  DESIGN_DNA_SHOWCASE_COMPONENTS_TABLE,
  DESIGN_DNA_SHOWCASE_INTRO_MARKDOWN,
  DESIGN_DNA_SHOWCASE_LAYOUT_MARKDOWN,
  DESIGN_DNA_SHOWCASE_WHITE_THEME_YAML,
} from './designDnaDemoContent.part03.js'
import { DESIGN_DNA_SHOWCASE_AI_LOG_STEPS } from './designDnaDemoContent.part04.js'

export function buildDesignDnaGenerationBlocks(htmlArtifactId, opts = {}) {
  const streaming = opts.streaming ?? false
  const showcaseLogBlock = streaming
    ? {
        type: 'aiResponseLog',
        status: 'ok',
        showLogStatus: false,
        stepTemplates: DESIGN_DNA_SHOWCASE_AI_LOG_STEPS,
      }
    : {
        type: 'aiResponseLog',
        status: 'ok',
        showLogStatus: false,
        steps: buildWorkflowTimeline(DESIGN_DNA_SHOWCASE_AI_LOG_STEPS),
      }

  return [
    buildSelectionSwitchBlock('agent', 'Design', 'Software Engineering'),
    { type: 'markdown', content: DESIGN_DNA_SHOWCASE_INTRO_MARKDOWN },
    {
      type: 'heading',
      level: 2,
      content: 'Design System Showcase — MUI Component Library',
    },
    {
      type: 'markdown',
      variant: 'muted',
      content: '*Built from the extracted Design DNA — everything below ships to Figma as variables and component sets.*',
    },
    { type: 'heading', level: 3, content: 'Design DNA Implemented' },
    { type: 'code', language: 'yaml', content: DESIGN_DNA_SHOWCASE_WHITE_THEME_YAML },
    { type: 'heading', level: 3, content: '60+ Components with All Variants' },
    { type: 'table', data: DESIGN_DNA_SHOWCASE_COMPONENTS_TABLE },
    { type: 'markdown', content: DESIGN_DNA_SHOWCASE_LAYOUT_MARKDOWN },
    {
      type: 'fileArtifact',
      fileName: 'MUI Component Showcase.html',
      description: 'HTML App',
      artifactKind: 'html',
      artifactId: htmlArtifactId,
    },
    { type: 'heading', level: 3, content: 'Build Trace — Fullstack Dev + Agent Browser' },
    showcaseLogBlock,
    buildSelectionSwitchBlock('persona', 'Architect', 'Founder'),
    { type: 'callout', style: 'success', content: DESIGN_DNA_SHOWCASE_COMPLETE_CALLOUT },
  ]
}

/**
 * @deprecated Use {@link buildDesignDnaPlanBlocks} and {@link buildDesignDnaGenerationBlocks}.
 * @param {string} dnaArtifactId
 * @param {string} showcaseArtifactId
 * @param {string} htmlArtifactId
 * @param {{ streaming?: boolean }} [opts]
 * @returns {object[]}
 */
